import { css, Theme } from "@emotion/react";

export const styles = {
  alert: (theme: Theme) =>
    css({
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),

      ".MuiAlert-action": {
        alignItems: "flex-end",
        paddingBottom: theme.spacing(0.95),
      },
    }),
  link: css({
    textDecoration: "underline",
  }),
  parsedDOMNode: css({
    color: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
  }),
  title: (theme: Theme) =>
    css({
      fontWeight: theme.typography.fontWeightSemiBold,
      marginBottom: 0,
    }),
};
